import React from 'react'
import { Dropdown, useModalContext } from '@sketch/components'
import { ShareForShareDropdown } from '../ShareActionsDropdown'
import { useIsProfileCreated } from '../../../../community/hooks'
import {
  UnpublishPublicationModal,
  PublishDocumentNowModal,
} from '../../../../community/modals'
import { ReactComponent as ProfileIcon } from '@sketch/icons/profile-card-17'

export interface PublishDocumentOptionProps {
  workspaceIdentifier: string
  share: ShareForShareDropdown
  isPublished: boolean
  publicCommentsEnabled: boolean
  publicInspectEnabled: boolean
  userCanAdminister?: boolean
}

export const PublishDocumentOption: React.FCC<PublishDocumentOptionProps> = ({
  workspaceIdentifier,
  share,
  isPublished,
  publicCommentsEnabled,
  publicInspectEnabled,
  userCanAdminister = false,
}) => {
  const { showModal } = useModalContext()

  const { isProfileCreated } = useIsProfileCreated(workspaceIdentifier)
  const isInDrafts = share.project?.projectType === 'PERSONAL_DRAFTS'

  if (!isProfileCreated || isInDrafts) {
    return null
  }

  const showPublishConfirmation = () => {
    showModal(PublishDocumentNowModal, {
      shareName: share.name,
      shareIdentifier: share.identifier,
      workspaceIdentifier,
      publicCommentsEnabled,
      publicInspectEnabled,
    })
  }

  const showUnpublishModal = () => {
    showModal(UnpublishPublicationModal, {
      shareName: share.name,
      shareIdentifier: share.identifier,
      workspaceIdentifier,
      publicCommentsEnabled,
      publicInspectEnabled,
      publicAccessLevel: share.publicAccessLevel,
    })
  }

  const handleClick = () => {
    if (isPublished) {
      showUnpublishModal()
    } else {
      showPublishConfirmation()
    }
  }

  // Only show "Remove from profile" option for admin users
  const showRemoveOption = isPublished && userCanAdminister
  const showPublishOption = !isPublished

  if (!showRemoveOption && !showPublishOption) {
    return null
  }

  return (
    <>
      <Dropdown.Divider />
      <Dropdown.Item
        icon={<ProfileIcon />}
        onClick={handleClick}
        intent={isPublished ? 'negative' : 'primary'}
      >
        {isPublished ? 'Remove from profile…' : 'Publish to Public profile'}
      </Dropdown.Item>
    </>
  )
}
